import React, { useState } from "react";
import { postData } from "../../../../services/api.service";

const FormBurgerVarieties = ({
  selectedBurger,
  varitiesBurger,
  id_branch,
}) => {
  const [varieties, setVarieties] = useState(varitiesBurger || []);
  const [newVariety, setNewVariety] = useState("");

  // Crear variedad
  const onAddVariety = async (e) => {
    e.preventDefault();
    if (!newVariety.trim()) return;

    const data = {
      type_id: selectedBurger.id,
      burger_description: newVariety,
      id_branch: id_branch,
    };
    const res = await postData("/api/admin/create_burguer_variety", data);
    if (res.status === 200) {
      setVarieties([
        ...varieties,
        { id: res.data.id, burger_description: newVariety },
      ]);

      setNewVariety("");
    }
  };

  // Eliminar variedad
  const onDeleteVariety = async (id) => {
    const data = {
      id: id,
      id_branch: id_branch,
    };
    const res = await postData("/api/admin/delete_burguer_variety", data);
    if (res.status === 200) {
      setVarieties(varieties.filter((v) => v.id !== id));
    }
  };

  return (
    <div>
      <h5 className="mb-3 text-center">
        Variedades de {selectedBurger.type_description}
      </h5>
      <form className="d-flex mb-3" onSubmit={onAddVariety}>
        <input
          type="text"
          className="form-control me-2"
          placeholder="Nueva variedad"
          value={newVariety}
          onChange={(e) => setNewVariety(e.target.value)}
        />
        <button type="submit" className="btn btn-primary">
          Agregar
        </button>
      </form>
      <ul className="list-group">
        {varieties.length === 0 && (
          <li className="list-group-item text-center text-muted">
            No hay variedades cargadas.
          </li>
        )}
        {varieties.map((v) => (
          <li
            key={v.id}
            className="list-group-item d-flex justify-content-between align-items-center"
          >
            {v.burger_description}
            <button
              className="btn btn-danger btn-sm"
              onClick={() => onDeleteVariety(v.id)}
            >
              Eliminar
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FormBurgerVarieties;
